import axios from 'axios';
import ConstantApi from '../../ConstantApi';
import { fetchAreaMaster } from '../areaMaster/areaMaster.actions';
import axiosCall from '../axiosCall';
import { fetchCommonPropertyById } from '../property/common/commonProperty.actions';
import {
    CREATE_PARTY_MASTER_FAILURE,
    CREATE_PARTY_MASTER_FORM,
    CREATE_PARTY_MASTER_REQUEST,
    CREATE_PARTY_MASTER_SUCCESS,
    DELETE_PARTY_MASTER_FAILURE,
    DELETE_PARTY_MASTER_REQUEST,
    DELETE_PARTY_MASTER_SUCCESS,
    FETCH_BANK_NAME_FAILURE,
    FETCH_BANK_NAME_REQUEST,
    FETCH_BANK_NAME_SUCCESS,
    FETCH_PARTY_MASTER_FAILURE,
    FETCH_PARTY_MASTER_GST_FILE_FAILURE,
    FETCH_PARTY_MASTER_GST_FILE_REQUEST,
    FETCH_PARTY_MASTER_GST_FILE_SUCCESS,
    FETCH_PARTY_MASTER_PAN_FILE_FAILURE,
    FETCH_PARTY_MASTER_PAN_FILE_REQUEST,
    FETCH_PARTY_MASTER_PAN_FILE_SUCCESS,
    FETCH_PARTY_MASTER_REQUEST,
    FETCH_PARTY_MASTER_SUCCESS,
    FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_FAILURE,
    FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_REQUEST,
    FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_SUCCESS,
    FETCH_SINGLE_PARTY_MASTER_FAILURE,
    FETCH_SINGLE_PARTY_MASTER_REQUEST,
    FETCH_SINGLE_PARTY_MASTER_SUCCESS,
    PARTY_MASTER_SET_ACTIVE_FAILURE,
    PARTY_MASTER_SET_ACTIVE_REQUEST,
    PARTY_MASTER_SET_ACTIVE_SUCCESS,
    RESET_PARTY_MASTER_INFO,
    SET_ACTIVE_KEY_PARTY_MASTER,
    UPDATE_PARTY_MASTER_FAILURE,
    UPDATE_PARTY_MASTER_REQUEST,
    UPDATE_PARTY_MASTER_SUCCESS
} from './partyMaster.actionsType';
import Config from '../../config';
import Cookies from 'js-cookie';

// FETCH PARTY MASTER DATA
export let fetchPartyMasterData = () => {
    let config = {
        method: 'get',
        // url: ConstantApi.partyMasterGET,
        url: ConstantApi.partyMasterGETALL,
        responseTypeRequest: FETCH_PARTY_MASTER_REQUEST,
        responseTypeSuccess: FETCH_PARTY_MASTER_SUCCESS,
        responseTypeFailure: FETCH_PARTY_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE PARTY MASTER FORM
export let createPartyDetailsForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_PARTY_MASTER_FORM, payload: { key, value } });
    };
};

export let setPartyMasterActiveKey = (key) => {
    return (dispatch) => {
        dispatch({ type: SET_ACTIVE_KEY_PARTY_MASTER, payload: key });
    };
};

// CREATE PARTY MASTER
export let createPartyMaster = (formData, modalClose) => {
    let today = new Date();
    // let data = JSON.stringify({
    //     fldId: 0,
    //     fldIsActive: true,
    //     fldCreatedBy: 1,
    //     fldCreatedDt: today.toISOString(),
    //     fldModifiedBy: 0,
    //     fldModifiedDt: today.toISOString(),
    //     fldDeletedBy: 0,
    //     fldDeletedDt: today.toISOString(),
    //     ...formData,
    //     fldAdditionalContactNumber: formData?.fldAdditionalContactNumber ? formData?.fldAdditionalContactNumber : '',
    //     fldMachineryInfo: formData?.fldMachineryInfo ? formData?.fldMachineryInfo : '',
    //     fldProductionCapacityPerDay: formData?.fldProductionCapacityPerDay ? formData?.fldProductionCapacityPerDay : '',
    //     fldGSTFileName: formData?.fldGSTFileName ? formData?.fldGSTFileName : '',
    //     fldPANFileName: formData?.fldPANFileName ? formData?.fldPANFileName : '',
    //     fldFKCategory: parseInt(formData.fldFKCategory),
    //     fldFKArea: parseInt(formData.fldFKArea),
    //     fldFKType: formData.fldUnitType[0] || 0,
    //     fldFKBankName: parseInt(formData.fldFKBankName),
    //     fldUnitType: formData.fldUnitType.toString(),
    //     FldBankName: 'string',
    //     fldTDS: formData.fldTDS.split('.').length >= 2 ? parseFloat(formData.fldTDS) : parseInt(formData.fldTDS),
    //     fldTCS: formData.fldTCS.split('.').length >= 2 ? parseFloat(formData.fldTCS) : parseInt(formData.fldTCS),
    //     FldUnitTypeDetails: 'string'
    // });
    let config = {
        method: 'post',
        data: formData,
        url: `${ConstantApi.partyMasterPOST}`,
        responseTypeRequest: CREATE_PARTY_MASTER_REQUEST,
        responseTypeSuccess: CREATE_PARTY_MASTER_SUCCESS,
        responseTypeFailure: CREATE_PARTY_MASTER_FAILURE,
        resetFormData: RESET_PARTY_MASTER_INFO,
        modalClose,
        singlApiArray: [modalClose ? setPartyMasterActiveKey(1) : ''],
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchPartyMasterData()
    };
    return axiosCall(config);
};

// GET SINGLE PARTY MASTER
export let getSinglePartyMaster = (id) => {
    // let config = {
    //     method: 'get',
    //     url: `${ConstantApi.partyMasterGETID}/${id}`,
    //     responseTypeRequest: FETCH_SINGLE_PARTY_MASTER_REQUEST,
    //     responseTypeSuccess: FETCH_SINGLE_PARTY_MASTER_SUCCESS,
    //     responseTypeFailure: FETCH_SINGLE_PARTY_MASTER_FAILURE,
    //     singlApiArray: [
    //         fetchPropertyDataForPartyMasterMaster(31), // Party Category
    //         fetchPropertyDataForPartyMasterMaster(23), // Program Type
    //         fetchCommonPropertyById(67),
    //         fetchAreaMaster(),
    //         fetchBankName()
    //     ]
    // };
    // return axiosCall(config);
    return (dispatch) => {
        dispatch({ type: FETCH_SINGLE_PARTY_MASTER_REQUEST });
        var config = {
            method: 'get',
            url: `${Config.baseUrl}${ConstantApi.partyMasterGETID}/${id}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                console.log(response?.data, 'lllllllllllllll');
                dispatch({ type: FETCH_SINGLE_PARTY_MASTER_SUCCESS, updatePayload: response.data });
                dispatch(fetchPartyMasterPANFile(response?.data?.fldPANFileName, response?.data?.fldId));
                dispatch(fetchPartyMasterGSTFile(response?.data?.fldGSTFileName, response?.data?.fldId));
                dispatch(fetchPropertyDataForPartyMasterMaster(31));
                dispatch(fetchPropertyDataForPartyMasterMaster(23));
                dispatch(fetchCommonPropertyById(67));
                dispatch(fetchAreaMaster());
                dispatch(fetchBankName()); //source
            })
            .catch((error) => {
                dispatch({ type: FETCH_SINGLE_PARTY_MASTER_FAILURE, payload: error });
            });
    };
};

export let fetchPartyMasterPANFile = (fileName, id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.partyMasterPANFileGET}?FldFileName=${fileName}&FldFileType=PAN&FldId=${id}`,
        responseTypeRequest: FETCH_PARTY_MASTER_PAN_FILE_REQUEST,
        responseTypeSuccess: FETCH_PARTY_MASTER_PAN_FILE_SUCCESS,
        responseTypeFailure: FETCH_PARTY_MASTER_PAN_FILE_FAILURE
    };
    return axiosCall(config);
};

export let fetchPartyMasterGSTFile = (fileName, id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.partyMasterPANFileGET}?FldFileName=${fileName}&FldFileType=GST&FldId=${id}`,
        responseTypeRequest: FETCH_PARTY_MASTER_GST_FILE_REQUEST,
        responseTypeSuccess: FETCH_PARTY_MASTER_GST_FILE_SUCCESS,
        responseTypeFailure: FETCH_PARTY_MASTER_GST_FILE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PARTY MASTER
export let updatePartyMaster = (formData, id) => {
    let today = new Date();
    // let data = {
    //     ...formData,
    //     fldAdditionalContactNumber: formData?.fldAdditionalContactNumber ? formData?.fldAdditionalContactNumber : '',
    //     fldMachineryInfo: formData?.fldMachineryInfo ? formData?.fldMachineryInfo : '',
    //     fldProductionCapacityPerDay: formData?.fldProductionCapacityPerDay ? formData?.fldProductionCapacityPerDay : '',
    //     fldGSTFileName: formData?.fldGSTFileName ? formData?.fldGSTFileName : '',
    //     fldPANFileName: formData?.fldPANFileName ? formData?.fldPANFileName : '',
    //     fldPartyCode: formData.fldPartyCode,
    //     fldModifiedBy: 1,
    //     fldModifiedDt: today.toISOString(),
    //     fldFKCategory: parseInt(formData.fldFKCategory),
    //     fldFKArea: parseInt(formData.fldFKArea),
    //     fldFKType: parseInt(formData.fldFKType),
    //     fldFKBankName: parseInt(formData.fldFKBankName),
    //     fldUnitType: formData.fldUnitType.toString(),
    //     fldTDS: formData.fldTDS.split('.').length >= 2 ? parseFloat(formData.fldTDS) : parseInt(formData.fldTDS),
    //     fldTCS: formData.fldTCS.split('.').length >= 2 ? parseFloat(formData.fldTCS) : parseInt(formData.fldTCS),
    //     FldUnitTypeDetails: formData.fldUnitTypeDetails
    // };
    let config = {
        method: 'patch',
        data: formData,
        url: `${ConstantApi.partyMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_PARTY_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_PARTY_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_PARTY_MASTER_FAILURE,
        resetFormData: RESET_PARTY_MASTER_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchPartyMasterData()
    };
    return axiosCall(config);
};

// DELETE PARTY MASTER
export let deletePartyMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.partyMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_PARTY_MASTER_REQUEST,
        responseTypeSuccess: DELETE_PARTY_MASTER_SUCCESS,
        responseTypeFailure: DELETE_PARTY_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchPartyMasterData()
    };
    return axiosCall(config);
};

export let fetchPropertyDataForPartyMasterMaster = (propertyId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${propertyId}`,
        responseTypeRequest: FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_REQUEST,
        responseTypeSuccess: FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_SUCCESS,
        responseTypeFailure: FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_FAILURE,
        payload: propertyId
    };
    return axiosCall(config);
};

// FETCH BANK NAME
export let fetchBankName = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.BankList}`,
        responseTypeRequest: FETCH_BANK_NAME_REQUEST,
        responseTypeSuccess: FETCH_BANK_NAME_SUCCESS,
        responseTypeFailure: FETCH_BANK_NAME_FAILURE
    };
    return axiosCall(config);
};

export let toggleSetActiveParty = (id) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.partyMasterGET_SET_ACTIVE}/${id}`,
        responseTypeRequest: PARTY_MASTER_SET_ACTIVE_REQUEST,
        responseTypeSuccess: PARTY_MASTER_SET_ACTIVE_SUCCESS,
        responseTypeFailure: PARTY_MASTER_SET_ACTIVE_FAILURE,
        getAllData: fetchPartyMasterData()
    };
    return axiosCall(config);
};
